function stringify(data) {
  try {
    return JSON.stringify(data);
  } catch (e) {
    return data;
  }
}

function parse(data) {
  try {
    return JSON.parse(data);
  } catch (error) {
    return data;
  }
}

export const setSessionStorage = (key: string, data: {} | any) => {
  sessionStorage.setItem(key, stringify(data));
};

export const getSessionStorage = (key: string) => {
  let value = sessionStorage.getItem(key);
  return parse(value);
};

export const removeSessionStorage = (key: string) => {
  sessionStorage.removeItem(key);
}

export const getSessionStorageAll = () => {
  return Object.keys(sessionStorage).reduce(function(obj, key) {
    obj[key] = getSessionStorage(key);
    return obj;
 }, {});
};